/* ── SIDE DRAWER ── */
class SideDrawer extends HTMLElement {
  connectedCallback() {
    /* Overlay click */
    this.querySelector('.drawer-overlay')
      ?.addEventListener('click', () => this.close());

    /* ALL close buttons */
    this.querySelectorAll('.drawer-close')
      .forEach(btn => {
        btn.addEventListener('click', () => this.close());
      });

    /* Click outside panel */
    this.addEventListener('click', (e) => {

      const panel = this.querySelector('.drawer-panel');

      if (!panel) return;

      if (!panel.contains(e.target)) {
        this.close();
      }

    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  open() {
    this.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.removeAttribute('open');
    document.body.style.overflow = '';
  }
}

customElements.define('side-drawer', SideDrawer);

/* ── SIDE CART ITEM ── */
class SideCartItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.variant_id = this.getAttribute('variant-id');
    this.itemCount  = Number(this.getAttribute('item-count'));
    this.sideCart   = this.closest('side-cart');

    this.querySelector('.cart-item__remove')
      ?.addEventListener('click', this.clearLineItem.bind(this));

    this.querySelector('[data-action="increase"]')
      ?.addEventListener('click', this.addQty.bind(this));

    this.querySelector('[data-action="decrease"]')
      ?.addEventListener('click', this.minusQty.bind(this));
  }

  updateCart(updates) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    })
    .then(res => res.json())
    .then(cart => {
      this.sideCart.cart = cart;
      this.sideCart.buildCart(cart);
    });
  }

  addQty()       { this.sideCart.classList.remove('loaded'); this.updateCart({ [this.variant_id]: this.itemCount + 1 }); }
  minusQty()     { this.sideCart.classList.remove('loaded'); this.updateCart({ [this.variant_id]: Math.max(0, this.itemCount - 1) }); }
  clearLineItem(){ this.sideCart.classList.remove('loaded'); this.updateCart({ [this.variant_id]: 0 }); }
}

customElements.define('side-cart-item', SideCartItem);

/* ── SIDE CART ── */
class SideCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    /* FIXED: closest() only works after element is in DOM */
    this.drawer       = this.closest('side-drawer');
    this.itemTemplate = this.querySelector('template#side-cart-item');
  }

  renderSideCartItem(context = {}) {
    const clone   = this.itemTemplate.content.cloneNode(true);
    const element = clone.querySelector('side-cart-item');
    const item    = context.item;

    element.setAttribute('variant-id', item.id);
    element.setAttribute('item-count',  item.quantity);

    element.innerHTML = element.innerHTML
      .replace(/\$\$IMAGE_URL\$\$/g,        item.image || '')
      .replace(/\$\$IMAGE_ALT\$\$/g,        item.featured_image?.alt || '')
      .replace(/\$\$ITEM_TITLE\$\$/g,       item.product_title)
      .replace(/\$\$ITEM_PRICE\$\$/g,       Shopify.formatMoney(item.final_line_price))
      .replace(/\$\$ITEM_QUANTITY\$\$/g,    item.quantity)
      .replace(
                /\$\$ITEM_VARIANT_TITLE\$\$/g,
                item.variant_title &&
                item.variant_title !== 'Default Title' &&
                item.variant_title !== 'null'
                  ? item.variant_title
                  : ''
              );

    return clone;
  }

  getCart() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        this.cart = cart;
        this.buildCart(cart);
        if (this.drawer) {
        this.drawer.open();
        }
      });
  }

  buildCart(cart) {
    const container = this.querySelector('#cart-items');
    container.innerHTML = '';

    if (!cart.items.length) {
      container.innerHTML = `
        <div class="side-cart-empty">

          <div class="side-cart-empty__icon">
            🛒
          </div>

          <div class="side-cart-empty__title">
            Your Bag is Empty
          </div>

          <button
            class="side-cart-empty__btn"
            onclick="window.location.href='/collections/all'"
          >
            Continue Shopping
          </button>

        </div>
      `;
    } else {
      cart.items.forEach(item => {
        container.appendChild(this.renderSideCartItem({ item }));
      });
    }
    const footer = this.querySelector('.side-cart-footer');

    if (footer) {
      footer.style.display = cart.items.length ? '' : 'none';
    }

    const totalEl = this.querySelector('#cart-total');
    if (totalEl) {
      totalEl.innerHTML = `
        <span class="side-cart-total__label">Total</span>
        <span class="side-cart-total__price">${Shopify.formatMoney(cart.total_price)}</span>
      `;
    }

    /* Update Dawn's header cart count bubble */
    document.querySelectorAll('.cart-count-bubble span, [data-cart-count]')
      .forEach(el => el.textContent = cart.item_count);

    this.classList.add('loaded');
    this.drawer?.open();
  }

  addLineItem(line_item) {
    if (this.cart) {
      line_item.final_line_price = line_item.final_price * line_item.quantity;
      const existing = this.cart.items.find(i => i.id == line_item.id);
      if (existing) {
        existing.quantity           = line_item.quantity;
        existing.final_line_price   = line_item.final_line_price;
      } else {
        this.cart.items.push(line_item);
      }
      this.cart.total_price = this.cart.items.reduce((a, b) => a + b.final_line_price, 0);
      this.buildCart(this.cart);
    } else {
      this.getCart();
    }
  }
}

customElements.define('side-cart', SideCart);

/* ── WIRING ── */
document.addEventListener('DOMContentLoaded', function () {

  /* Cart icon → open drawer */
  document.addEventListener('click', function (e) {
    const cartLink = e.target.closest('a[href="/cart"], .header__icon--cart');
    if (!cartLink || cartLink.closest('side-drawer')) return;

    const sideCart = document.querySelector('side-cart');
    if (!sideCart) return; // ← side cart not found, let default navigation work

    e.preventDefault();
    sideCart.getCart();
  });

  /* Add to cart → intercept only if side cart is available */
 /* =========================================
   UNIVERSAL ADD TO CART INTERCEPT
========================================= */

document.addEventListener('submit', async function (e) {

  const form = e.target.closest('form[action*="/cart/add"]');

  if (!form) return;

  const sideCart = document.querySelector('side-cart');

  if (!sideCart) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const submitBtn = form.querySelector('[type="submit"]');

  if (submitBtn) {
    submitBtn.disabled = true;
  }

  try {

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: new FormData(form)
    });

    if (!response.ok) {
      throw new Error('Cart add failed');
    }

    await response.json();

    sideCart.getCart();

  } catch (error) {

    console.error('[Side Cart]', error);

    window.location.href = '/cart';

  } finally {

    if (submitBtn) {
      submitBtn.disabled = false;
    }

  }

}, true);

});